import React from 'react';
import PropTypes from 'prop-types';
import { logger } from 'packages';

class ApplicationErrorBoundary extends React.Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        const { capture } = this.props;
        if (capture) capture(error);
    }

    render() {
        const { hasError } = this.state;
        const { children, fallback } = this.props;
        return hasError ? fallback : children;
    }
}

ApplicationErrorBoundary.propTypes = {
    // Capture function, if false then errors are silently ignored
    capture: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).isRequired,
    fallback: PropTypes.node
};

ApplicationErrorBoundary.defaultProps = {
    capture: logger,
    fallback: null
};

export default ApplicationErrorBoundary;
